import { render, staticRenderFns } from "./card_fila.vue?vue&type=template&id=ce02257c&scoped=true"
import script from "./card_fila.vue?vue&type=script&lang=js"
export * from "./card_fila.vue?vue&type=script&lang=js"
import style0 from "./card_fila.vue?vue&type=style&index=0&id=ce02257c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce02257c",
  null
  
)

export default component.exports